import { createActions } from 'redux-actions';

export const { updateProtocolRules } = createActions('UPDATE_PROTOCOL_RULES');
